import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Radio,
  Upload,
  message,
  Icon,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import {
  axiosAuthInstance,
  axiosEmptyInstance,
  API_END_POINTS,
} from 'api';
import { NOTIFICATION } from 'store/actionTypes';
import { notificationActions } from 'store/actions';
import { MESSAGES } from 'appconstants';
import {
  SpError,
  SpText,
} from 'components/DesignKit';
import Previewicon from 'components/NavIcons/previewIcon';
import Uploadicon from 'components/NavIcons/uploadIcon';
import imageOnError from 'utils/imageOnError';

type Props = {
  printInfo: Object,
  setNotification: Function,
};

const Print = forwardRef((props: Props, ref) => {
  const {
    printInfo,
    setNotification,
  } = props;

  const [, forceUpdate] = useState();
  const [withLogo, setWithLogo] = useState(printInfo.withLogo || false);
  const [printLogo, setPrintLogo] = useState(printInfo.printLogo ? true : !printInfo.withLogo);
  const [loader, setLoading] = useState(false);
  const [preview, setPreview] = useState(printInfo.printLogo ? (
    // eslint-disable-next-line max-len
    <img src={`${printInfo.printLogo}?time=${new Date().getTime()}`} alt="" onError={event => imageOnError(event)} style={{ width: '100%' }} />) : '');
  const [fileName, setFileName] = useState('');
  const simpleValidator = useRef(new SimpleReactValidator());

  const uploadButton = (
    <div>
      {loader ? <Icon type="loading" /> : <Uploadicon />}
      <div className="ant-upload-text mt-2">Click or drag the file here to upload</div>
      <div className="mt-2"><SpText color="rgba(0, 0, 0, 0.45)">Support extension：.pdf .jpg .png</SpText></div>
    </div>
  );

  const beforeUpload = (file) => {
    const isLt5M = file.size / 1024 / 1024 < 5;
    const PDF = 'application/pdf';
    const IMAGE = 'image/*';
    const pattern = file.type.match(IMAGE) || file.type.match(PDF);
    if (!pattern) {
      message.error('File is not image or pdf');
      return false;
    }
    if (pattern && !isLt5M) {
      message.error('File must smaller than 5MB!');
      return false;
    }
    return true;
  };

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const fileReader = async file => new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsArrayBuffer(file);
  });

  const fileUpload = async (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    try {
      setLoading(true);
      const file = info.file.originFileObj;
      if (file) {
        const { data: { entity } } = await axiosAuthInstance.get(`${API_END_POINTS.UPLOAD_KIOSK}`);
        await axiosEmptyInstance.put(entity, await fileReader(file), { headers: { 'Content-Type': file.type } });
        const { data: { entity: { fileUrl } } } = await axiosAuthInstance.post(`${API_END_POINTS.UPLOAD_KIOSK}`, { fileUrl: entity });
        setPrintLogo(fileUrl);
        printInfo.printLogo = fileUrl;
        const pattern = /image*/;
        if (file.type.match(pattern)) {
          getBase64(file, imageUrl => {
            setPreview(<img src={imageUrl} alt="..." style={{ width: '115px' }} />);
          });
        } else {
          setPreview(<Previewicon />);
        }
        setFileName(info.file.name);
      }
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: MESSAGES.FILE_UPLOAD.ERROR,
      });
    } finally {
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    validate: () => {
      const formValid = simpleValidator.current.allValid();
      if (!formValid) {
        simpleValidator.current.showMessages();
        forceUpdate(1);
        return false;
      }
      printInfo.withLogo = withLogo;
      printInfo.printLogo = printLogo;
      printInfo.fileName = fileName;
      return true;
    },
  }));

  return (
    <>
      <div>
        <Row>
          <Col span={6}>
            <Radio.Group
              onChange={e => { setWithLogo(e.target.value); printInfo.withLogo = e.target.value; }}
              value={withLogo}
            >
              <Radio value className="ml-2">With Logo <span style={{ color: 'red' }}>*</span></Radio>
              <Radio value={false}>Without Logo</Radio>
            </Radio.Group>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col span={6}>
            <Upload
              name="avatar"
              listType="picture-card upload-card"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={beforeUpload}
              onChange={fileUpload}
            >
              {preview || uploadButton}
            </Upload>
            <SpError>
              {simpleValidator.current.message('logo', printLogo, 'required')}
            </SpError>
          </Col>
        </Row>
      </div>
    </>
  );
});

const mapDispatchToProps = (dispatch) => ({
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
});

// $FlowFixMe
export default connect(
  null,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(Print);
